import { useCallback } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';

import { collectLeaveOrder, leaveWithRateLimitRetry } from './utils';

const useLeaveWorkspace = () => {
  const { matrixClient } = useMatrixContext();

  const leaveWorkspace = useCallback(
    async (workspaceId: string, includeSubWorkspaceRooms = false) => {
      const leaveOrder = await collectLeaveOrder(matrixClient, workspaceId, includeSubWorkspaceRooms);

      for (const roomId of leaveOrder) await leaveWithRateLimitRetry(matrixClient, roomId);
    },
    [matrixClient]
  );

  return { leaveWorkspace };
};

export default useLeaveWorkspace;
